
const configuration =  {
    BACKEND_URL: 'http://localhost:3002'
}

export default configuration;